import { useEffect, useState } from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import { supabase, isConfigured } from '../lib/supabase.js'
import Seo from '../components/Seo.jsx'

export default function Unsubscribe() {
  const [params] = useSearchParams()
  const token = params.get('token')
  const [status, setStatus] = useState('working') // working | done | error | notoken

  useEffect(() => {
    if (!token) return setStatus('notoken')
    if (!isConfigured) return setStatus('error')
    // Account reminder tokens live in notification_settings; promo-list tokens
    // live in leads. Try the account unsubscribe first, then the lead one, so a
    // single page handles both kinds of link.
    ;(async () => {
      const acct = await supabase.rpc('unsubscribe', { p_token: token })
      if (!acct.error && acct.data) return setStatus('done')
      const lead = await supabase.rpc('unsubscribe_lead', { p_token: token })
      setStatus(!lead.error && lead.data ? 'done' : 'error')
    })()
  }, [token])

  return (
    <main className="page">
      <Seo title="Unsubscribe | CalculateMyPeptides" />
      <div className="container page-narrow" style={{ maxWidth: 520 }}>
        <div className="card card-pad center" style={{ padding: '40px 30px' }}>
          {status === 'working' && (<><div className="spinner" /><p className="muted" style={{ marginTop: 14 }}>Updating your preferences…</p></>)}
          {status === 'done' && (
            <>
              <div style={{ fontSize: '2.4rem', marginBottom: 8 }}>✅</div>
              <h1 className="section-title">You’re unsubscribed</h1>
              <p className="soft">You won’t receive further reminder or update emails. You can turn them back on
                anytime from your notification settings.</p>
              <Link to="/settings" className="btn btn-primary" style={{ marginTop: 12 }}>Notification settings</Link>
            </>
          )}
          {(status === 'error' || status === 'notoken') && (
            <>
              <div style={{ fontSize: '2.4rem', marginBottom: 8 }}>⚠️</div>
              <h1 className="section-title">Couldn’t process that</h1>
              <p className="soft">This unsubscribe link looks invalid or expired. You can manage your emails
                directly from your account instead.</p>
              <Link to="/settings" className="btn btn-primary" style={{ marginTop: 12 }}>Notification settings</Link>
            </>
          )}
        </div>
      </div>
    </main>
  )
}
